import { IconProps } from './icons-props';

function CrownOutIcon({ className, width = 21, height = 20 }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 21 20'
            fill='none'
            className={className}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.0698 3.24463C10.4261 2.88848 11.0742 2.89309 11.4185 3.24268L11.4214 3.24463L14.4126 6.23682C14.6747 6.49889 15.1258 6.5302 15.4106 6.23584L15.4116 6.23682L17.5698 4.07861C17.8966 3.75185 18.1571 3.64263 18.3296 3.60889C18.5002 3.57561 18.6304 3.60756 18.7153 3.64014C18.7937 3.67412 18.9029 3.74086 18.9966 3.88135C19.0937 4.0271 19.1997 4.2903 19.1997 4.7583V12.7515C19.2035 14.0652 18.7652 15.1274 18.0327 15.8599C17.3 16.5925 16.2354 17.0327 14.9165 17.0327H6.5835C4.21804 17.0327 2.29161 15.1071 2.2915 12.7417V4.7583C2.2915 4.29515 2.39755 4.03102 2.49561 3.8833C2.59367 3.73569 2.70773 3.66789 2.78369 3.63623C2.86018 3.60436 2.98819 3.57159 3.16064 3.60596C3.33307 3.64036 3.59372 3.75095 3.92139 4.07861L6.07959 6.23682C6.34171 6.4989 6.79283 6.53036 7.07764 6.23584L7.07861 6.23682L10.0698 3.24463ZM11.2446 3.4292C10.9936 3.17863 10.5692 3.13872 10.2837 3.39404L10.2466 3.4292L7.26318 6.4126C6.90694 6.76884 6.25888 6.76515 5.91455 6.41553L3.75342 4.25439C3.57355 4.07455 3.42688 3.98214 3.33936 3.93213L2.82959 3.64111L2.62354 4.19092C2.56992 4.3339 2.5415 4.52453 2.5415 4.7583V12.7495C2.5415 14.9757 4.35735 16.7915 6.5835 16.7915H14.9165C16.1014 16.7915 17.1218 16.4055 17.8472 15.6802C18.5724 14.9548 18.9585 13.9343 18.9585 12.7495V4.7583C18.9585 4.52098 18.9291 4.34017 18.8765 4.19971L18.6812 3.6792L18.1841 3.92725C18.0569 3.99087 17.9148 4.09499 17.7466 4.26318L15.5884 6.42139C15.2322 6.77752 14.5842 6.77361 14.2397 6.42432L11.2446 3.4292Z'
                fill='currentColor'
                stroke='currentColor'
            />
        </svg>
    );
}

export default CrownOutIcon;

